import { w as writable } from "./index2.js";
const tariffs = writable([]);
export {
  tariffs as t
};
//# sourceMappingURL=tariffs.js.map
